import { ButtonLinkComp } from '@website/lib-shared/src/components/blocks/ButtonLink/ButtonLinkComp.js';

import type { RepaymentCalculatorPresetProps } from '../types/RepaymentCalculatorPresetProps.js';

export const createPresetPartnerRepaymentCalculator = ({
  ctaLink,
  ctaLabel,
}: {
  ctaLink: string;
  ctaLabel: string;
}): RepaymentCalculatorPresetProps => ({
  content: {
    followUp: ctaLink && ctaLabel && <ButtonLinkComp linkReference={{ url: ctaLink }}>{ctaLabel}</ButtonLinkComp>,
    resultAction: <ButtonLinkComp linkReference={{ url: ctaLink }}>{ctaLabel}</ButtonLinkComp>,
  },
});
